export default {"src":"/_next/static/media/contacts.22a1b5c2.svg","height":13,"width":16,"blurWidth":0,"blurHeight":0};